/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DateRangeActivated,
  DateRangeActivatedOptional,
  DateRangeActivatedMetaI,
  DateRangeActivatedTrackedI,
} from "./date-range-activated";
import {
  DateRangeActivatedTracked,
  DateRangeActivatedMeta,
} from "./date-range-activated";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAddressRef,
  PersonAddressRefOptional,
  PersonAddressRefMetaI,
  PersonAddressRefTrackedI,
} from "./person-address-ref";
import {
  PersonAddressRefTracked,
  PersonAddressRefMeta,
} from "./person-address-ref";

/**
 *
 * @export
 * @interface PersonAddressBase
 */
export interface PersonAddressBaseOptional extends DateRangeActivatedOptional {
  /**
   *
   * @type {number}
   * @memberof PersonAddressBase
   */
  personAddressAssignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  endActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonAddressBase
   */
  isPrimary?: boolean;
}

export interface PersonAddressBase
  extends PersonAddressBaseOptional, DateRangeActivated, PersonAddressRef {
  /**
   *
   * @type {number}
   * @memberof PersonAddressBase
   */
  personAddressAssignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  endActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonAddressBase
   */
  isPrimary?: boolean;
}

export interface PersonAddressBaseTrackedI extends DateRangeActivatedOptional {
  /**
   *
   * @type {number}
   * @memberof PersonAddressBase
   */
  personAddressAssignId?: number;
  personAddressAssignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAddressBase
   */
  name?: string;
  nameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonAddressBase
   */
  isPrimary?: boolean;
  isPrimaryIsSet: boolean;
}

transformDatesMap.set("PersonAddressBase", function (model: PersonAddressBase) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
});

export type PersonAddressBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personAddressAssignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  name: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isPrimary: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var PersonAddressBaseMeta: PersonAddressBaseMetaI =
  {} as PersonAddressBaseMetaI;
PersonAddressBaseMeta = typeMeta("PersonAddressBase", {
  personAddressAssignId: propertyMeta(
    "personAddressAssignId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  name: propertyMeta("name", false, false, false, MetaTypesBase.string),
  isPrimary: propertyMeta(
    "isPrimary",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = PersonAddressBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PersonAddressRefMeta]);
  metaI.personAddressAssignId.inheritedFrom =
    PersonAddressRefMeta.personAddressAssignId;
  metaI.interfaces = metaI.interfaces.concat([DateRangeActivatedMeta]);
  metaI.startActive.inheritedFrom = DateRangeActivatedMeta.startActive;
  metaI.endActive.inheritedFrom = DateRangeActivatedMeta.endActive;
});

export class PersonAddressBaseTracked
  extends DateRangeActivatedTracked
  implements PersonAddressBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  personAddressAssignId__I?: number = undefined;

  get personAddressAssignIdIsSet() {
    return this.personAddressAssignId !== undefined;
  }
  set personAddressAssignIdIsSet(v: boolean) {}
  set personAddressAssignId(v: undefined | number) {
    if (v !== undefined) {
      this.personAddressAssignId__I = v;
      this.personAddressAssignIdIsSet = true;
    } else {
      this.personAddressAssignId__I = v || undefined;
      this.personAddressAssignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personAddressAssignId() {
    return this.personAddressAssignId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  name__I?: string = undefined;
  nameIsSet: boolean = false;
  set name(v: undefined | string) {
    if (v !== undefined) {
      this.name__I = v;
      this.nameIsSet = true;
    } else {
      this.name__I = v || undefined;
      this.nameIsSet = false;
    }
    this.changeTracker = true;
  }
  get name() {
    return this.name__I;
  }
  isPrimary__I?: boolean = undefined;
  isPrimaryIsSet: boolean = false;
  set isPrimary(v: undefined | boolean) {
    if (v !== undefined) {
      this.isPrimary__I = v;
      this.isPrimaryIsSet = true;
    } else {
      this.isPrimary__I = v || undefined;
      this.isPrimaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get isPrimary() {
    return this.isPrimary__I;
  }
  constructor(config?: PersonAddressBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (
      this.personAddressAssignIdIsSet == true &&
      other?.personAddressAssignIdIsSet == true
    )
      return this.personAddressAssignId == other.personAddressAssignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.personAddressAssignId) {
      this.personAddressAssignIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonAddressBaseOptional,
    options?: AssignOptions,
  ): PersonAddressBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.personAddressAssignId &&
      this.personAddressAssignIdApplyFilter(optionsRequired.filter)
    ) {
      this.personAddressAssignId = config.personAddressAssignId;
      if (optionsRequired.unassign) this.personAddressAssignIdIsSet = false;
      else this.personAddressAssignIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (config.name && this.nameApplyFilter(optionsRequired.filter)) {
      this.name = config.name;
      if (optionsRequired.unassign) this.nameIsSet = false;
      else this.nameIsSet = true;
    }
    if (config.isPrimary && this.isPrimaryApplyFilter(optionsRequired.filter)) {
      this.isPrimary = config.isPrimary;
      if (optionsRequired.unassign) this.isPrimaryIsSet = false;
      else this.isPrimaryIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAddressBaseTrackedI {
    const cloned = {} as PersonAddressBaseTrackedI;
    if (
      this.personAddressAssignIdIsSetDeep() &&
      this.personAddressAssignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personAddressAssignIdIsSet = true;
      cloned.personAddressAssignId = this.personAddressAssignId;
    } else {
      //cloned.personAddressAssignIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.nameIsSetDeep() &&
      this.nameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nameIsSet = true;
      cloned.name = this.name;
    } else {
      //cloned.nameIsSet = false
    }
    if (
      this.isPrimaryIsSetDeep() &&
      this.isPrimaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isPrimaryIsSet = true;
      cloned.isPrimary = this.isPrimary;
    } else {
      //cloned.isPrimaryIsSet = false
    }
    if (!isDeleted(this) && !this.personAddressAssignIdIsSet)
      updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAddressBaseTrackedI {
    if (!this.personAddressAssignIdApplyFilter(filter))
      this.personAddressAssignIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.nameApplyFilter(filter)) this.nameIsSet = false;

    if (!this.isPrimaryApplyFilter(filter)) this.isPrimaryIsSet = false;

    return this;
  }
  personAddressAssignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAddressBaseMeta.personAddressAssignId,
      PersonAddressBaseMeta,
      this.personAddressAssignId,
      this,
    );
  }
  personAddressAssignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.personAddressAssignIdIsSet &&
      this.personAddressAssignIdApplyFilter(filter)
    )
      return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAddressBaseMeta.startActive,
      PersonAddressBaseMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAddressBaseMeta.endActive,
      PersonAddressBaseMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  nameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAddressBaseMeta.name,
      PersonAddressBaseMeta,
      this.name,
      this,
    );
  }
  nameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nameIsSet && this.nameApplyFilter(filter)) return true;

    return false;
  }
  isPrimaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAddressBaseMeta.isPrimary,
      PersonAddressBaseMeta,
      this.isPrimary,
      this,
    );
  }
  isPrimaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isPrimaryIsSet && this.isPrimaryApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personAddressAssignIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.nameIsSetDeep(filter)) return true;
    if (this.isPrimaryIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
